import React, { useEffect, useState } from "react";
import { setLoading } from "../../../../stores/MainStore/MainStore";
import { AppError } from "../../../../services/classes";
import { toast } from "react-toastify";
import { WeekContainer } from "./WeekScheduleStyles";
import { getStationSchedule } from "../../../../services/schedulerSettingsService";
import { FullSchedule } from "../../../../types/schedulerSettings.types";
import { weekdaysArr } from "../../../../utils/consts";
import Weekday from "./Weekday";

interface Props {
  stationId: string;
}

const WeekSchedule: React.FC<Props> = ({ stationId }) => {
  const [schedule, setSchedule] = useState<FullSchedule | null>(null);

  useEffect(() => {
    if (stationId) {
      handleGetStationSchedule();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stationId]);

  const handleGetStationSchedule = () => {
    setLoading(true);

    getStationSchedule(stationId)
      .then((res) => {
        setSchedule(res);
      })
      .catch((err: AppError) => {
        console.log(err.message);
        toast.error(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const renderWeekdays = () => {
    if (!schedule) {
      return <div>Agendamento vazio.</div>;
    }

    return weekdaysArr.map((day) => (
      <Weekday
        key={day.enum}
        weekdayName={day.nameBr}
        daySchedule={schedule[day.enum]}
      />
    ));
  };

  return <WeekContainer>{schedule && renderWeekdays()}</WeekContainer>;
};

export default WeekSchedule;
